import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer';
import Avatar from "../../components/Avatar";
import Chat from "../../components/Chat";
import { PuffLoader } from "react-spinners";
import Intro from "../../components/IntroMultiVideo";
import StartScreen from "../../components/StartScreen";
import Menu from "../../components/Menu/menu";
import HospitalIntro from "../../components/HospitalIntro";

const AvatarPageHospital = () => {
  const { avatarId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [response, setResponse] = useState("");
  const [readyToAnswer, setReady] = useState(false);
  const [readyRepeat, setReadyRepeat] = useState(false);
  const [avatarReady, setAvatarReady] = useState(false);
  const [startSession, setStartSession] = useState(false);
  const [isFirstVisit, setFirstVisit] = useState(true);
  const [submittedChat, setSubmittedChat] = useState([]);
  const [submittedName, setSubmittedName] = useState("User");
  const [menuVisible, setMenuVisible] = useState(false);
  const [isSubmitLoading, setSubmitloading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [canvasElementShow, setCanvasElementShow] = useState(true);
  const [videoElementShow, setVideoElementShow] = useState(false);
  const [textExpressionElementShow, setTextExpressionElementShow] = useState(false)
  const [language, setLanguage] = useState("english");
  const [topic, setTopic] = useState("JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB");
  const [selectedAvatar, setAvatar] = useState();
  const [avatarName, setAvatarName] = useState();
  const [token, setToken] = useState();
  const [showTranscript, setShowTranscript] = useState(false);
  const [transcriptChatList, setTranscriptChatList] = useState([]);
  const [chatList, setChatList] = useState([]);
  const [transcriptList, setTranscriptList] = useState([]);
  const [isSubmitted, setSubmitted] = useState(false);
  const [isImage, setIsImage] = useState();
  const [url, setURL] = useState();
  const [messages, setMessages] = useState("");
  const [APIConnection, setAPIConnection] = useState(true);
  const [mobileConnection, setMobileConnection] = useState(true);
  const [voiceConnection, setVoiceConnection] = useState(true);
  const [videoURL, setVideoURL] = useState()
  const [expression, setExpression] = useState()
  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [alreadyIdle, setAlreadyIdle] = useState(false)
  const [showStartScreen, setShowStartScreen] = useState(true)
  const [fromHomepage, setFromHomepage] = useState(false)
  const [isSwitching, setIsSwitching] = useState(false)
  const [finishIntro, setFinishIntro] = useState(false)

  const maxRetryCount = 3;
  const maxDelaySec = 4;

  const [orientation, setOrientation] = useState("");
  const [device, setDevice] = useState("");

  const [avatarList, setAvatarList] = useState([])
  const [topicList, setTopicList] = useState([])
  const [idleURL, setIdleURL] = useState("")
  const [talkURL, setTalkURL] = useState("")

  const [selectedMenu, setSelectedMenu] = useState("MENU");

  useEffect(() => {
    // Function to update the orientation state
    function updateOrientation() {
      // eslint-disable-next-line no-restricted-globals
      setOrientation(screen.orientation.type);
      /Mobi|Android|iPhone/i.test(navigator.userAgent)
        ? setDevice("mobile")
        : setDevice("desktop");
    }

    // Initial update of the orientation state
    updateOrientation();
    // Add an event listener for orientation change
    window.addEventListener("orientationchange", updateOrientation);
    window.addEventListener("resize", updateOrientation);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
    };
  }, [orientation]);

  const updateNetworkStatus = () => {
    console.log(navigator.onLine)
    setMobileConnection(navigator.onLine);
    !navigator.onLine && alert("Check your internet connection and try again") 
  };

  async function fetchWithRetries(url, options, retries = 1) {
    try {
      const response = await fetch(url, options)
      if (!response.ok) {  
        setAPIConnection(false)
        throw new Error("API ERROR")
      }else{
        return response
      }
    } catch (err) {
      if (retries <= maxRetryCount) {
        const delay =
          Math.min(Math.pow(2, retries) / 4 + Math.random(), maxDelaySec) *
          1000;

        await new Promise((resolve) => setTimeout(resolve, delay));

        console.log(
          `Request failed, retrying ${retries}/${maxRetryCount}. Error ${err}`
        );
        return fetchWithRetries(url, options, retries + 1);
      } else {
        setAPIConnection(false)
        throw new Error(`Max retries exceeded. error: ${err}`);
      }
    }
  }

  async function login(){
    const login = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/auth/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: process.env.REACT_APP_FXAI_AUTH_EMAIL,
          password: process.env.REACT_APP_FXAI_AUTH_PASS,
        }),
      }
    );

    var response = await login.json();
    if (response.result === "OK") {
      setToken(response.data.authToken);
      setAPIConnection(true)
    }else{
      setAPIConnection(false)
    }
  }

  const handleStartSession = async () => {
    setStartSession(true);
  };

  const pullTopicData = async () => {
    const getTopicList = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/key/public`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }
    );
    var topicList = await getTopicList.json()
    setTopicList(topicList.data)
  }

  const pullAvatarData = async (topic, language) => {
    const getAvatarList = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/config/passphrase/${topic}/language/${language}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }
    );
    var avatarList = await getAvatarList.json()
    setAvatarList(avatarList.data)
  }

  const pullData = async () => {
    localStorage.setItem("firstVisit", false);
    pullTopicData();
    pullAvatarData(topic, language);
  }

  const handleRefresh = () => {
    if(language === "english"){
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Are you sure you want to restart?")){
        localStorage.removeItem("firstVisit");
        window.location.reload();
      }
    }else{
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Apakah kamu yakin mau memuat ulang halaman?")){
        localStorage.removeItem("firstVisit");
        window.location.reload();
      }
    }
    
    
    
  };

  const handleShowMenu = () => {
    setMenuVisible(!menuVisible);
    setSelectedMenu("MENU")
  };

  const pushMessage = (recipient, msg, role, sources, transcript_msg) => {
    if (recipient == "AI") {
      setChatList([
        ...chatList,
        {
          recipient: "",
          type: recipient,
          message: msg,
          source: sources,
          url: url,
          format: isImage,
        },
      ]);
      setTranscriptChatList([
        ...transcriptChatList,
        {
          recipient: "",
          type: recipient,
          message: transcript_msg,
        },
      ]);
      setSubmittedChat([
        ...submittedChat,
        {
          content: msg,
          role: role,
          created_at: new Date().toString(),
        },
      ]);
      setTranscriptList([
        ...transcriptList,
        {
          Name:avatarId,
          Message: transcript_msg,
        },
      ]);
    } else {
      setChatList([
        ...chatList,
        {
          recipient: recipient,
          type: recipient,
          message: msg,
        },
      ]);
      setSubmittedChat([
        ...submittedChat,
        {
          content: msg,
          role: role,
          created_at: new Date().toString(),
        },
      ]);
      setTranscriptChatList([
        ...transcriptChatList,
        {
          recipient: recipient,
          type: recipient,
          message: transcript_msg,
        },
      ]);
      setTranscriptList([
        ...transcriptList,
        {
          Name: submittedName !== "" ? submittedName : "You",
          Message: transcript_msg,
        },
      ]);
    }

    setMessages(msg);
    setURL("")
  };

  const handleSendMessage = (message) => {
    setSubmitted(true);
    pushMessage(localStorage.getItem("username"), message, "user", null, message);
    setTimeout(() => {
      setIsLoading(true);
    }, 1000);
  };

  const resetChatHistory = () => {
    setChatList([]);
    setTranscriptChatList([]);
    setSubmittedChat([]);
    setTranscriptList([]);
  }

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
    
    if(menu === "LOCALISATION"){
      setAvatarReady(false);
      handleShowMenu();
      language === "english" ? setLanguage("indonesia") : setLanguage("english")
      language === "english" ? localStorage.setItem("language", "indonesia") : localStorage.setItem("language", "english")
      // language === "english" ? setAvatar(parseInt(selectedAvatar)+1) : setAvatar(parseInt(selectedAvatar)-1)
      // language === "english" ? localStorage.setItem("avatar_id",parseInt(selectedAvatar)+1) : localStorage.setItem("avatar_id",parseInt(selectedAvatar)-1)
    }
    if(menu !== "CHANGE AVATAR" && menu !== "CHANGE TOPIC"){
      handleShowMenu()
    }
    if(menu === "EXPORT"){
      handleShowMenu()
      setShowTranscript(true)
    }
  };

  const handleSelectAvatar = (avatar) => {
    window.location.href = `${avatar.name.toLowerCase().split(" ").join("")}?topic=${topic}`;
  }

  const handleSetTopic = (topic) => {
    if(language === "english"){
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Do you want to change the topic?")){
        setIsSwitching(true)
        resetChatHistory();
        localStorage.setItem("topic_id", topic.passphrase);
        setTopic(topic.passphrase);
        pullAvatarData(topic.passphrase, language);
        handleShowMenu()
      }
    }else{
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Apakah kamu ingin mengganti topik")){
        setIsSwitching(true)
        resetChatHistory();
        localStorage.setItem("topic_id", topic.passphrase);
        setTopic(topic.passphrase);
        pullAvatarData(topic.passphrase, language);
        handleShowMenu()
      }
    }
    
  }

  // No Activity detection
  const onIdle = () => {
    if(!alreadyIdle && avatarReady && !isFirstVisit){
      // setAlreadyIdle(true);
      if(language === "english"){
        pushMessage("AI","Hi, are you still there? anything else on your mind?","ai",null,"Hi, are you still there? anything else on your mind?")
        document.getElementById("vo").src =
          `${process.env.PUBLIC_URL}/assets/video-avatar/${avatarName}_noactivity_en.mp3`;
        document.getElementById("vo").play();
      }else{
        pushMessage("AI","Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?","ai",null,"Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?")
        document.getElementById("vo").src =
        `${process.env.PUBLIC_URL}/assets/video-avatar/${avatarName}_noactivity_id.mp3`;
      document.getElementById("vo").play();
      }
    }
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: 60_000,
    throttle: 500,
    events:[
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'MSPointerDown',
    ]
  })

  useEffect(() => {
    window.addEventListener("load", updateNetworkStatus);
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
        window.removeEventListener("load", updateNetworkStatus);
        window.removeEventListener("online", updateNetworkStatus);
        window.removeEventListener("offline", updateNetworkStatus);
    };
  }, [navigator.onLine]);

  useEffect(() => {
    localStorage.getItem('username')
      ? setSubmittedName(localStorage.getItem('username'))
      : setSubmittedName("User")
    localStorage.getItem("language")
      ? setLanguage(localStorage.getItem("language"))
      : setLanguage("english");
    searchParams.get("topic")
      ? setTopic(searchParams.get("topic"))
      : setTopic("JkOACSfNY6xSX6PV8241EdATjeIcKWXzKAxB");
    updateNetworkStatus();
    login();
    if(searchParams.get("homepage")){
      setFromHomepage(true)
    }
  }, []);

  useEffect(() => {
    if(token){
      pullAvatarData(topic, language);
    }
  }, [language])

  useEffect(() => {
    if(startSession && token){
      pullData();
      
    }
  },[startSession, token])

  useEffect(() => {
    if (avatarList && avatarList.length > 0){
      
      let filteredAvatarList = avatarList.filter(avatar => avatar.avatar.name.toLocaleLowerCase() === avatarId.toLocaleLowerCase())

      if(filteredAvatarList.length > 0){
        if (filteredAvatarList[0].avatar.expressions){
          setIdleURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.expressions.idleHyperlink)
        setTalkURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.expressions.talkHyperlink)
        setVideoURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.expressions.talkHyperlink)
        }else{
          setIdleURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.idleHyperlink)
          setTalkURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.talkingHyperlink)
          setVideoURL(process.env.REACT_APP_FXAI_SERVER_URL + filteredAvatarList[0].avatar.talkingHyperlink)
        }
        setAvatar(filteredAvatarList[0].id)
        setAvatarName(avatarId.toLocaleLowerCase())
      }else{
        setErrorMessage(language === "english" ? "Avatar not available in selected topic/ language, please select another avatar" : "Avatar tidak tersedia di topik/ bahasa yang dipilih, mohon pilih avatar lain")
        setShowError(true)
      }
     
    }
  }, [avatarList])

  useEffect(() => {
    if(isSwitching){
      let filteredAvatarList = avatarList.filter(avatar => avatar.avatar.name.toLocaleLowerCase() === avatarId.toLocaleLowerCase())
      if(filteredAvatarList.length > 0){

      }else{
        setErrorMessage(language === "english" ? "Avatar not available in selected topic/ language, please select another avatar" : "Avatar tidak tersedia di topik/ bahasa yang dipilih, mohon pilih avatar lain")
        setShowError(true)
      }
      setIsSwitching(false)
    }
      
  }, [isSwitching])

  useEffect(() => {
    if(idleURL && talkURL){
      setAvatarReady(true)
    }
  }, [idleURL, talkURL, selectedAvatar])

  useEffect(() => {
    if(!isFirstVisit){
      setTimeout(() => {
        setFinishIntro(true)
      }, 1000)
    }
  }, [isFirstVisit])

  return (
    <div className="outer-container">
      <div
        className={`container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" ||
            orientation === "landscape-secondary")
            ? "hide"
            : "show"
        } hospital`}
      >
         <div className="connection">
        <div className={`connection-bar ${!mobileConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/connection.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!APIConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/llm.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!voiceConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/voice.svg`}></img>
          <div className="dot"></div>
        </div>
       </div>
        <span className="version">v2.5.5</span>
        <div className="bottom-logo"><img src={`${process.env.PUBLIC_URL}/assets/logo.png`} /></div>
        
        {
        !startSession && showStartScreen ?
        fromHomepage ? 
        <div className="start-click" onClick={() => handleStartSession()}>{language === "english" ? "Tap anywhere to start a conversation" : "Ketuk disini untuk mulai mengobrol"}</div> :
        <StartScreen
        language={language}
        handleStartSession={handleStartSession}
        videoSrc={`${process.env.PUBLIC_URL}/assets/hospital_start.mp4`}
        source={"hospital"}
      /> :
        <>
          <div className={`loading-container ${avatarReady ? 'hide' : ''}`}>
            <PuffLoader color="#fff" size={100} />
            <span className="loading-container_text">
            {language === "english"
                  ? "Preparing the session..."
                  : "Menyiapkan sesi..."}
            </span>
          </div>
          <div className={`error-container ${showError ? '' : 'hide'}`}>
            <span className="error-container_text">
            {errorMessage}
            </span>
            <a className="error-container_button" href={`./?topic=${topic}`}>{language === "english" ? "Select Avatar" : "Pilih Avatar"}</a>
          </div>
          
          {isFirstVisit ? (
            <HospitalIntro
              avatar={avatarId}
              language={language}
              setSubmittedName={setSubmittedName}
              setFirstVisit={setFirstVisit}
              setResponse={setResponse}
              isSubmitLoading={isSubmitLoading}
              setSubmitloading={setSubmitloading}
              handleSendMessage={handleSendMessage}
              idleURL={idleURL}
              source={"hospital"}
            />
          ) : (
            <>             
              {menuVisible ? (
                  <div className="Menu">
                  <Menu
                      handleShowMenu={handleShowMenu}
                      language={language}
                      topicList={topicList}
                      selectedTopic={topic}
                      avatarList={avatarList}
                      handleSelectAvatar={handleSelectAvatar}
                      handleSetTopic={handleSetTopic}
                      handleMenuClick={handleMenuClick}
                      selectedMenu={selectedMenu}
                      source={"hospital"}
                  />
                </div>
              ) : (
                <div className="navbar">
                  <div className="refresh-menu" onClick={handleRefresh}>
                    <img src={`${process.env.PUBLIC_URL}/assets/hospital_refresh.png`} alt="Refresh" />
                  </div>
                  <div className="show-menu" onClick={handleShowMenu}>
                    <img src={`${process.env.PUBLIC_URL}/assets/hospital_menu.png`} alt="Show Menu" />
                  </div>
                </div>
              )}

              <Avatar
                avatar={selectedAvatar}
                canvasElementShow={canvasElementShow}
                videoElementShow={videoElementShow}
                isstartSession={startSession}
                videoURL={videoURL}
                talkUrl={talkURL}
                idleURL={idleURL}
                origin={"hospital"}
              />
              <Chat
                setSubmitted={setSubmitted}
                pushMessage={pushMessage}
                isSubmitted={isSubmitted}
                messages={messages}
                chatList={chatList}
                transcriptChatList={transcriptChatList}
                transcriptList={transcriptList}
                handleSendMessage={handleSendMessage}
                setIsImage={setIsImage}
                setURL={setURL}
                avatar={selectedAvatar}
                setShowTranscript={setShowTranscript}
                showTranscript={showTranscript}
                topic={topic}
                token={token}
                setReadyRepeat={setReadyRepeat}
                readyRepeat={readyRepeat}
                language={language}
                setCanvasElementShow={setCanvasElementShow}
                setVideoElementShow={setVideoElementShow}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                submittedName={submittedName}
                setSubmittedName={setSubmittedName}
                submittedChat={submittedChat}
                response={response}
                setResponse={setResponse}
                readyToAnswer={readyToAnswer}
                setReady={setReady}
                fetchWithRetries={fetchWithRetries}
                setSubmittedChat={setSubmittedChat}
                setVideoURL={setVideoURL}
                setExpression={setExpression}
                talkURL={talkURL}
                avatarName={avatarName}
                setVoiceConnection={setVoiceConnection}
                origin={"hospital"}
                setTextExpressionElementShow={setTextExpressionElementShow}
              />
              <div className="expression-detail">Elevenlabs</div>
              <div className="llm-detail">OpenAI gpt4o</div>

              <div className={`loading-container ${finishIntro ? 'hide' : ''}`}>
                <PuffLoader color="#fff" size={100} />
                <span className="loading-container_text">
                {language === "english"
                      ? "Preparing the session..."
                      : "Menyiapkan sesi..."}
                </span>
              </div>
            </>
          )}
          {/* <video autoPlay muted loop id="video-bg" playsInline>
            <source src="../assets/hospital_bg.mp4" type="video/mp4" />
          </video> */}
        </>
          
        }
        
      </div>
      <div
        className={`rotate-container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" ||
            orientation === "landscape-secondary")
            ? "show"
            : "hide"
        }`}
      >
        <img className="rotate-img" src={`${process.env.PUBLIC_URL}/assets/rotate.png`} />
      </div>
      
    </div>
  );
}

export default AvatarPageHospital;
